import script from "./ReportingPagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportingPagePage.vue?vue&type=script&setup=true&lang=js"

import "./ReportingPagePage.vue?vue&type=style&index=0&id=217a9274&lang=css"

const __exports__ = script;

export default __exports__